document.addEventListener("DOMContentLoaded", function () {
  // Small delay to let theme.min.js initialize
  setTimeout(function () {
    // Get product JSON (variants + prices)
    var productJsonEl = document.getElementById("ProductJson-1");
    if (!productJsonEl) return;

    var productData;
    try {
      productData = JSON.parse(productJsonEl.textContent || productJsonEl.innerHTML);
    } catch (e) {
      return;
    }
    if (!productData || !productData.variants) return;

    function getCurrentVariant() {
      var select = document.getElementById("productSelect-1");
      if (!select) return null;
      var selectedId = parseInt(select.value, 10);
      if (!selectedId) return null;
      for (var i = 0; i < productData.variants.length; i++) {
        if (productData.variants[i].id === selectedId) {
          return productData.variants[i];
        }
      }
      return null;
    }

    function applyHalfOff() {
      // Always re-select the current price wrapper – theme may re-render it
      var priceWrapper = document.querySelector(".product-single__price.js-product-price");
      if (!priceWrapper) return;

      var saleActiveAttr = priceWrapper.getAttribute("data-sale-active");
      var saleActive = saleActiveAttr && saleActiveAttr.toLowerCase() === "true";
      if (!saleActive) return; // Only run on tagged/date-active sale products

      var priceNumberContainer = priceWrapper.querySelector(".js-product-price-number");
      var compareContainer = priceWrapper.querySelector(".js-product-price-compare");
      if (!priceNumberContainer) return;

      var variant = getCurrentVariant();
      if (!variant || typeof Shopify === "undefined" || typeof Shopify.formatMoney !== "function") {
        return;
      }

      // variant.price is in cents
      var discountedPrice = Math.round(variant.price * 0.5); // <-- change 0.5 if discount % changes
      var expectedDiscountHtml = Shopify.formatMoney(discountedPrice, theme.money_format);

      var moneyEl = priceNumberContainer.querySelector(".money");
      if (moneyEl && moneyEl.innerHTML.trim() === expectedDiscountHtml.trim()) {
        // Already showing the discounted price – avoid rewriting endlessly
        return;
      }

      // Main discounted price
      priceNumberContainer.innerHTML =
        '<span class="product-single__price-number product-single__price-number--sale">' +
          '<span class="money">' +
            expectedDiscountHtml +
          "</span>" +
        "</span>";

      // Crossed-out original price
      if (compareContainer) {
        compareContainer.innerHTML =
          '<s class="product-single__price-compare">' +
            '<span class="money">' +
              Shopify.formatMoney(variant.price, theme.money_format) +
            "</span>" +
          "</s>";
      }
    }

    // Apply once on page load
    applyHalfOff();

    // Watch the price area for any changes (theme updates it on variant change)
    var priceWrapperInitial = document.querySelector(".product-single__price.js-product-price");
    if (!priceWrapperInitial) return;

    var observer = new MutationObserver(function () {
      // Whenever theme changes the price DOM, re-apply our discount
      applyHalfOff();
    });

    observer.observe(priceWrapperInitial, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }, 0);
});
